// Match the carousel frame to the selected image, including mixed image formats.
const initializedGalleries = new WeakSet();
function initializeNaturalGalleries(root = document) {
  for (const gallery of root.querySelectorAll('media-gallery.ma-natural-gallery')) {
    if (initializedGalleries.has(gallery)) continue;
    initializedGalleries.add(gallery);
    const slides = gallery.querySelector('slideshow-slides');
    if (!slides) continue;
    let queued = false;
    const update = () => {
      queued = false;
      const active = slides.querySelector('slideshow-slide[aria-hidden="false"] .product-media') || slides.querySelector('.product-media');
      const ratio = Number.parseFloat(active?.style.getPropertyValue('--ratio'));
      if (Number.isFinite(ratio) && ratio > 0) gallery.style.setProperty('--ma-selected-media-ratio', String(ratio));
    };
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(update);
    });
    observer.observe(slides, {subtree: true, attributes: true, attributeFilter: ['aria-hidden'], childList: true});
    update();
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeNaturalGalleries(), {once: true});
else initializeNaturalGalleries();
document.addEventListener('shopify:section:load', event => initializeNaturalGalleries(event.target));
